module.exports = __webpack_public_path__ + "img/775.aee71313.jpg";